import { render, staticRenderFns } from "./CompetencyLink.vue?vue&type=template&id=7b6ebf26&"
import script from "./CompetencyLink.vue?vue&type=script&lang=js&"
export * from "./CompetencyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports